import { ReactElement } from 'react';

import { Translate, useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { dischargeSummaryTranslationKeys } from '../../../translations';

import { MedicalFieldAutosuggest } from './MedicalFieldAutosuggest';
import { MedicalFieldFormBean, MedicalFieldFormController } from './MedicalFieldForm.types';

type MedicalFieldSelectFormChildrenRenderProps = Pick<MedicalFieldFormController, 'handleSubmit' | 'formState'>;

type MedicalFieldSelectFormProps = {
   children: (props: MedicalFieldSelectFormChildrenRenderProps) => ReactElement;
};

export const MedicalFieldSelectForm = (props: MedicalFieldSelectFormProps): ReactElement => {
   const { register, handleSubmit, formState } = useFormController<MedicalFieldFormBean>({
      medicalField: null,
   });
   return (
      <StyledFlex as={'form'} direction={'column'} gap={'12px'} noValidate>
         <Translate>{dischargeSummaryTranslationKeys.informationRequiredForEDM}</Translate>
         <MedicalFieldAutosuggest register={register} />
         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledFlex>
   );
};
